<template>
  <div class="detail-page" v-loading="pageShow">
    <!-- header 头部 -->
    <div class="header">
      <header class="header-con">
        <img class="logo" src="./images/logo.png" alt="logo">
        <div class="user-info">
          <span>{{ userLogin.nick }}</span>
          <span><img style="width: 40px; height: 40px; margin-left: 5px;border-radius: 50%;" :src="userLogin.header" alt="头像"></span>
        </div>
      </header>
    </div>

    <!-- 播放器 -->
    <div class="player-con">
      <div class="player-content">
        <!-- 封面 -->
        <div class="cover-con">
          <img :src="coverImg" alt="直播封面">
        </div>
        <!-- 课程详情 -->
        <div class="course-info">
          <div class="course-item" v-for="(item, index) in courseItems" :key="index">
            <span class="index-con">0{{ index + 1 }}</span>
            <div class="course-detail">
              <p class="title-info">
                <span class="left-title">
                  <span class="play-type">{{ item.type }}</span>
                  <span class="course-title">{{ item.name }}</span>
                </span>
                <span class="status">{{ item.status }}</span>
                <i :class="item.show? 'el-icon-arrow-up' : 'el-icon-arrow-down'" style="color: #888888;cursor: pointer;" v-if="item.type === '回放'" @click="changeList(item)"></i>
              </p>
              <div class="time" v-if="false">
                <span>{{ item.start_time }}</span>
                <span style="margin-left: 10px;">{{ item.end_time }}</span>
              </div>
              <!-- 如果是回放的就显示 -->
              <div class="playback-con" v-if="item.backVideoArr && item.backVideoArr.length > 0 && item.show">
                <div class="back-item" v-for="(list, i) in item.backVideoArr" :key="i">
                  <p class="name-info">
                    <i class="el-icon-video-play"></i>
                    <span class="name-title" :title="list.title">{{ list.title }}</span>
                  </p>
                  <span class="back-time" :title="list.create_time">{{ list.create_time }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 立即购买 -->
    <div class="price-info">
      <div class="price-content">
        <div class="price-con">
          <span class="now-price">¥{{ discount_price? discount_price: price }}</span>
          <span v-if="discount_price" class="old-price">¥{{ price }}</span>
        </div>
        <!-- 购买按钮 -->
        <div class="buy-btn" @click="buyNowFn">立即购买</div>
      </div>
    </div>
    <!-- 图文互动 -->
    <div class="info-title-con">
      <div class="title-content">
        <p class="info-title">
          <span class="title">图文互动</span>
          <span class="line"></span>
        </p>
      </div>
    </div>

    <div class="info-main">
      <div class="info-content" v-html="detailGraphicsText">
      </div>
    </div>
    <!-- 底部 -->
    <div class="zizhipc">
      <div class="xinxiyang">
        <div class="xiaotan">
          <p style="font-size: 18px;color: #fff;">公司信息</p>
        </div>
      </div>
      <p style="color: rgb(238, 240, 241);margin-top: 20px;font-size: 16px;">
        珊瑚云直播提供技术支持
      </p>
      <p style="margin-top: 10px;">
        <a
          style="color: rgb(238, 240, 241);font-size: 16px;"
          href="https://www.shanhuketang.com/index.html"
          >www.shanhuketang.com</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import tool, { payOpenClassHost } from '@/kits/Tools.js'
import qs from 'qs'

export default {
  name: 'DetailPage',
  components: {
  },
  data () {
    return {
      // 登录
      pageShow: false,
      login: false,
      userLogin: {},
      qrcodeShow: false,
      qrcodeObj: null,
      initAllData: null,
      qrcodema: '',
      ds_id: '',
      isLocalCode: '',
      qqqrcodema: '',
      loginTimer: null,
      coverImg: '',
      opid: '',
      // 登录结束
      price: 998,
      discount_price: 188,
      detailGraphicsText: '',
      courseItems: [
        {
          name: '',
          type: '回放',
          status: '',
          time: '',
          show: true,
          backVideoArr: []
        }
      ],
      userName: '',
      fans_id: '',
      playStatus: '',
      defaultAvatar: '',
      isShowTeacherQrCode: false,
      isFinite: false,
      isThreeScreenCourse: false,
      isShowLivePage: false,
      isToday: false,
      ext: [],
      title: '',
      // 机构id
      uid: '',
      channel_id: ''
    }
  },
  methods: {
    changeList (item) {
      item.show = !item.show
    },
    async getDsIdFn () {
      const data = await this.axios.post(
        tool.baseUrl2() + '/customer/channel/getDsIdByChannelId',
        'channel_code=' + this.channel_id, { timeout: 6000 }
      )
      if (data.data.code === 200) {
        this.ds_id = data.data.data.ds_id
        this.getDetailGraphicsText()
        this.getDetailPageFn()
      } else {
        this.$alert(data.data.message, '', {
          showConfirmButton: false,
          showClose: false,
          type: 'warning',
          center: true
        })
        return false
      }
    },
    // 图文详情
    getDetailGraphicsText () {
      this.pageShow = true
      const tencentOssUrl = `${tool.tencentOssUrl()}/ds/larave_cache/dsCache_${this.ds_id}.json?${new Date().getTime()}${parseInt(Math.random() * 10e4)}`
      // const tencentOssUrl = `https://tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com/ds/larave_cache/dsCache_333759.json?17163425039198726`
      this.axios.get(tencentOssUrl, { timeout: 2000 }).then(res => {
        res.data.ds_menu.forEach(item => {
          if (item.cid === 3) {
            this.detailGraphicsText = item.content
          }
        })
        // 右侧视频列表
        this.courseItems = []
        const obj = {
          name: res.data.direct_seeding.name,
          type: res.data.direct_seeding.break_point ? '回放' : '直播',
          status: '',
          start_time: '',
          end_time: '',
          show: true,
          backVideoArr: res.data.direct_seeding.break_point
        }
        this.courseItems.push(obj)
        // 机构id
        this.uid = res.data.direct_seeding.uid
        localStorage.setItem('uid', res.data.direct_seeding.uid)
        this.pageShow = false
      }).catch(() => {
        // 没有缓存走/index
        this.axios.post(this.beseUrl + '/init/index/index', 'ds_id=' + this.ds_id, {timeout: 5000})
          .then(res => {
            if (res.data.code === 200) {
              // 图文详情
              res.data.data.ds_menu.forEach(item => {
                if (item.cid === 3) {
                  this.detailGraphicsText = item.content
                }
              })
              // 右侧视频列表
              this.courseItems = []
              const obj = {
                name: res.data.data.direct_seeding.name,
                type: '回放',
                status: '',
                start_time: res.data.data.direct_seeding.real_start_time,
                end_time: res.data.data.direct_seeding.real_end_time,
                show: true,
                backVideoArr: res.data.data.direct_seeding.break_point
              }
              this.courseItems.push(obj)
              // 机构id
              this.uid = res.data.data.direct_seeding.uid
              localStorage.setItem('uid', res.data.data.direct_seeding.uid)
              this.pageShow = false
            } else {
              this.$message.error(res.data.message)
              this.pageShow = false
            }
          }).catch(error => {
            console.log(error)
            this.pageShow = false
          })
      })
    },
    buyNowFn () {
      // 跳转到支付
      this.$router.push({
        name: 'Pay'
      })
    },
    getDetailPageFn () {
      const params = {
        ds_id: this.ds_id,
        fans_id: this.fans_id
      }
      const url = `${payOpenClassHost()}/liveapi/api/ds/payOpenInfo`
      this.axios.post(url, qs.stringify(params)).then(res => {
        if (res.data.code === 200) {
          // 封面
          this.coverImg = res.data.data.cover || ''
          // 价格
          const params = JSON.parse(res.data.data.params)
          this.price = params.price
          this.discount_price = params.discount_price
          this.ext = params.ext
          this.title = res.data.data.name
          // 传给支付的opid
          this.opid = params.opid
          if (res.data.data && res.data.data.is_pay) {
            this.$router.push({name: 'index'})
          }
        } else {
          this.$router.push({name: 'index'})
        }
      }).catch(err => {
        // 跳转回首页
        console.log(err)
        this.$router.push({name: 'index'})
      })
    }
  },
  computed: {},
  watch: {},
  created () {
    this.ds_id = tool.getQueryString('ds_id')
    if (tool.getCookie('userInfo')) {
      this.userLogin = JSON.parse(tool.getCookie('userInfo'))
      console.log(this.userLogin)
      this.login = true
    }
    this.fans_id = localStorage.getItem('fans_id')
    this.channel_id = tool.getQueryString('channel_id')
    // 请求详情页接口
    if (!this.ds_id && this.channel_id) {
      // 没有ds_id 先获取ds_id
      this.getDsIdFn()
    } else {
      this.getDetailPageFn()
      this.getDetailGraphicsText()
    }
  },
  mounted () {}
}
</script>

<style scoped>
.detail-page {
  background-color: #f5f6f7;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  overflow-y: auto;
}
.header {
  width: 100%;
  padding: 0 40px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.header-con {
    width: 1260px;
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-con .logo {
  width: 178px;
  height: 44px;
  object-fit: cover;
}
.user-info {
  display: flex;
  align-items: center;
}

/* 播放 */
.player-con {
  width: 100%;
  height: 500px;
  box-sizing: border-box;
  background: #f5f6f7;
  padding: 10px 40px;
  display: flex;
  justify-content: center;
}
.player-content {
  width: 1260px;
  height: 100%;
  display: flex;
}
.player-con .cover-con {
  width: 70%;
  height: 100%;
  background: #ccc;
}
.player-con .cover-con img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.player-con .course-info {
  width: 30%;
  height: 100%;
  background: #191a20;
  box-sizing: border-box;
  padding: 10px 0;
  overflow-y: auto;
}
/* 课程列 */
.course-info .course-item {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.course-item .index-con {
  font-size: 18px;
  color: #68686B;
}
.course-item .course-detail {
  width: calc(100% - 25px);
  height: auto;
}
.course-detail .title-info {
  display: flex;
  height: 25px;
  justify-content: space-between;
  align-items: flex-start;
}

.title-info .left-title {
  width: 195px;
  display: flex;
}

.left-title .play-type {
  padding: 2px 4px;
  margin-right: 10px;
  background: #1872ed;
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-title .course-title {
  max-width: calc(100% - 50px);
  color: #B7B7B7;
  font-size: 16px;
  /* 超出点点点 */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.title-info .status {
  color: #B7B7B7;
  font-size: 12px;
}
.course-detail .time {
  width: 100%;
  height: 20px;
  margin: 10px 0 20px 0;
  font-size: 12px;
  color: #B7B7B7;
}

.course-detail .playback-con {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.back-item {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.name-info {
  display: flex;
  align-items: center;
  width: calc(100% - 145px);
}
.name-info .name-title {
  display: inline-block;
  margin-left: 5px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  color: #b7b7b7;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name-info .name-title:hover {
  overflow: visible;
  width: 150px;
  white-space: normal;
  display: flex;
  line-height: 18px;
}

.name-info .el-icon-video-play {
  color: #888888;
}

.playback-con .back-item {
  width: 100%;
  height: 25px;
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back-item .back-time {
  font-size: 14px;
  color: #b7b7b7;
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-info {
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding: 0 40px;
  box-sizing: border-box;
}

.price-content {
  width: 1260px;
  height: 100%;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
}

.price-content .price-con .now-price {
  font-size: 40px;
  font-weight: 600;
  color: #FF3700;
}

.price-content .price-con .old-price {
  font-size: 18px;
  text-decoration: line-through;
  color: #939393;
}

/* 购买按钮 */
.buy-btn {
  width: 300px;
  height: 60px;
  background: linear-gradient(98deg,#ff704c 0%, #ff5227 100%);
  border-radius: 100px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
}

.info-title-con{
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.title-content {
  width: 1260px;
}
.info-title {
  margin-top: 40px;
  box-sizing: border-box;
  width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.info-title .title {
  font-family: PingFang SC, PingFang SC-400;
  font-size: 24px;
  color: #202020;
  font-weight: bold;
}
.info-title .line {
  margin-top: 10px;
  width: 40px;
  height: 4px;
  background: linear-gradient(96deg,#89bbff 0%, #0053ff 100%);

}
.info-main {
  width: 100%;
  padding: 0 40px;
  margin-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.info-content {
  width: 1260px !important;
  min-height: 200px;
  box-sizing: border-box;
}
.title-info {
  font-size: 20px;
  color: #232323;
}
.strip-con {
  width: 100%;
  height: auto;
  min-height: 100px;
}

.title-info {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #333;
}
.con-info {
  box-sizing: border-box;
  width: 100%;
  height: 200px;
  padding: 25px 40px;
  font-size: 18px;
  color: #232323;
}
.con-info {
  /* 课程内容 */
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

/* 底部样式 */
.zizhipc {
  overflow: hidden;
  height: 130px;
  background: rgb(21, 21, 21);
  text-align: center;
}

.xinxiyang {
  width: 100px;
  padding-top: 20px;
  display: flex;
  margin: 0 auto;
}

.xiaotan {
  width: 100px;
  height: 22px;
  text-align: center;
  /* border-right: 1px solid #000; */
}

</style>



// WEBPACK FOOTER //
// src/components/paidPublicClass/DetailPage.vue